import { createModule } from '../createModule';

export const proposalStatus = createModule('proposalStatus', {
  url: 'proposal_status'
});